import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import Skeleton from 'react-loading-skeleton';

import { Container } from 'styles';
import { EventCardList } from 'components/home';
import { SectionTitle, EventCard } from 'components/standalone';
import { Event, HomeState } from 'store/ducks/home/types';
import { getFeaturedEvents } from '../../store/ducks/home/actions';
import { SwiperContainer } from 'styles/Swiper';

interface StateProps {
	home: HomeState;
}

const HomeFeaturedEvents = () => {
	const select = (state: StateProps) => state.home;
	const dispatch = useDispatch();
	const { featuredEvents, loadingFeaturedEvents } = useSelector(select);
	const getFeaturedEventsFun = () => getFeaturedEvents();

	useEffect(() => {
		dispatch(getFeaturedEventsFun());
	}, [dispatch]);

	return (
		<>
			<Container>
				{!loadingFeaturedEvents && !isMobile && featuredEvents.length > 0 && (
					<>
						<SectionTitle text="Em alta" marginBottom={10} marginTop={60} size={20} />
						<EventCardList lineItems={3} gap={25}>
							{featuredEvents.map(({
								name,
								banner,
								thumbnail,
								startDate,
								locationName,
								locationType,
								url,
								seatsMapActived,
								hasFacebookPixel,
							}: Event) => (
								<EventCard
									key={url}
									name={name}
									banner={banner}
									thumbnail={thumbnail}
									startDate={startDate}
									locationName={locationName}
									locationType={locationType}
									url={url}
									seatsMapActived={seatsMapActived}
									short={false}
									main={true}
									hasFacebookPixel={hasFacebookPixel}
								/>
							))}
						</EventCardList>
					</>
				)}
				{loadingFeaturedEvents && !isMobile && (
					<EventCardList lineItems={3}>
						<Skeleton height={340} style={{ marginTop: '60px'}} />
						<Skeleton height={340} style={{ marginTop: '60px'}} />
						<Skeleton height={340} style={{ marginTop: '60px'}} />
					</EventCardList>
				)}
			</Container>

			{isMobile && !loadingFeaturedEvents && featuredEvents.length > 0 && (
				<>
					<Container>
						<SectionTitle text="Em alta" marginBottom={10} marginTop={60} size={20} />
					</Container>

					<SwiperContainer>
						<Swiper slidesPerView={1.25} loop={false} centeredSlides={true} spaceBetween={20}>
							{featuredEvents.map(({
								name,
								banner,
								thumbnail,
								startDate,
								locationName,
								locationType,
								url,
								seatsMapActived,
								hasFacebookPixel,
							}: Event) => (
								<SwiperSlide>
									<EventCard
										name={name}
										banner={banner}
										thumbnail={thumbnail}
										startDate={startDate}
										locationName={locationName}
										locationType={locationType}
										url={url}
										seatsMapActived={seatsMapActived}
										short={false}
										main={true}
										hasFacebookPixel={hasFacebookPixel}
									/>
								</SwiperSlide>
							))}
						</Swiper>
					</SwiperContainer>
				</>
			)}

			{isMobile && loadingFeaturedEvents && (<Skeleton height={340} style={{ width: '90%', margin: '60px 5% 0'}} />)}
		</>
	);
};

export default HomeFeaturedEvents;
